import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import NewsLetter from '../components/NewsLetter';

class Home extends Component {
    constructor(props) {
        super(props)
        this.state = {
            wTab: 'business',
            lightboxOverlay: false
        }


    }

    setLightboxOverlay(prop, e) {
        e.preventDefault();
        this.setState({
            lightboxOverlay: prop
        })
    }

    render() {
        const { wTab } = this.state;
        const { trans } = this.props;
        return (
            <div>
                <Header trans={trans}
                    active="home"
                    className="image-hero busines-2"
                    style={{backgroundImage: 'url(/static/images/header-photo.jpg)'}}
                    title="Design and Develop Chatbots. Visually."
                    body="Publish your chatbot from ready-to-use templates and start engaging customers on Messenger or Websites automatically">
                    <a style={{opacity: 1, transition: 'opacity 500ms ease 0s'}}
                        href="#"
                        data-ix="fade-in-on-load-3"
                        className="button w-button">
                        {trans('GET STARTED')}&nbsp;{trans('free')}
                    </a>
                </Header>
                <div className="section">
                    <div className="container w-container">
                        <div className="section-title-wrapper full-centered">
                            <h2 className="section-title">
                                {trans('Why HansaBot for Chatbots')}
                            </h2>
                            <div className="section-description desc-what-is-chatbot">
                                {trans('Chatbot development is less about programming but more about mastering conversations and languages HansaBot eases out the development effort with our powerful visual editor and let you focus more on understanding your audience and improving your chatbots continuously')}
                            </div>
                        </div>
                        <div data-duration-in="300" data-duration-out="100" className="portfolio-tabs w-tabs">
                            <div className="portfolio-tabs-menu w-tab-menu">
                                <div className={"portfolio-tab-button w-inline-block w-tab-link"+(wTab === "developers"  ? " w--current" : "")}
                                    onClick={() => this.setState({wTab: 'developers'})}>
                                    <div>{trans('Developers')}</div>
                                </div>
                                <div className={"portfolio-tab-button w-inline-block w-tab-link"+(wTab === "business"  ? " w--current" : "")}
                                    onClick={() => this.setState({wTab: 'business'})}>
                                    <div>{trans('Business')}</div>
                                </div>
                                <div className={"portfolio-tab-button w-inline-block w-tab-link"+(wTab === "marketers"  ? " w--current" : "")}
                                    onClick={() => this.setState({wTab: 'marketers'})}>
                                    <div>{trans('Marketers')}</div>
                                </div>
                            </div>
                            <div className="w-tab-content">
                                <div className={"portfolio-tab-pane w-tab-pane"+(wTab === "developers"  ? " w--tab-active" : "")}>
                                    <div className="portfolio-list-wrapper w-dyn-list">
                                        <div className="portfolio-list w-clearfix w-dyn-items w-row">
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a data-ix="show-lightbox"
                                                    className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf679ab62e424d7bccc992_Easy%2520Integration.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage: 'url(/static/images/5abf679ab62e424d7bccc992_Easy%2520Integration.png)'}} className="portfolio-item-block"></div>
                                                    <div className="portfolio-item-title">{trans('Easy Integrations')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('It is super easy to integrate your HansaBot chatbot with existing platforms or 3rd party systems through Zapier or our upcoming APIs')}
                                                    </p>
                                                </a>
                                            </div>
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a href="#" data-ix="show-lightbox" className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf67fb61e36535ccad75c5_Easy%2520Learning%2520Curve.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage: 'url(/static/images/5abf67fb61e36535ccad75c5_Easy%2520Learning%2520Curve.png)'}} className="portfolio-item-block"></div>
                                                    <div className="portfolio-item-title">{trans('Easy Learning Curve')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('Drag and Drop Visual Editor speeds up the chatbot design and development process everything is configurable at UI level')}
                                                    </p>
                                                </a>
                                            </div>
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a href="#" data-ix="show-lightbox" className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf6804d0f26427b0fb1bef_Powerful%2520%2520Scalability.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage: 'url(/static/images/5abf6804d0f26427b0fb1bef_Powerful%2520%2520Scalability.png)'}} className="portfolio-item-block">
                                                    </div>
                                                    <div className="portfolio-item-title">{trans('Powerful and Scalable')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('HansaBot is not a dumbed-down platform as advanced chatbot creators can enjoy magics such as NodeJS coding Nested and Modular Block NLP integration')}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"portfolio-tab-pane w-tab-pane"+(wTab === "business"  ? " w--tab-active" : "")}>
                                    <div className="portfolio-list-wrapper w-dyn-list">
                                        <div className="portfolio-list w-clearfix w-dyn-items w-row">
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a href="#" data-ix="show-lightbox" className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf67680c89188650a357bc_Better%2520Customer%2520Service.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage: 'url(/static/images/5abf67680c89188650a357bc_Better%2520Customer%2520Service.png)'}} className="portfolio-item-block"></div>
                                                    <div className="portfolio-item-title">{trans('Better Customer Service')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('Chatbots provide much faster responding rates and reduce workload for your customer support agents as they are available 24/7')}
                                                    </p>
                                                </a>
                                            </div>
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a href="#" data-ix="show-lightbox" className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf677361e36504dead75ac_Centralised%2520Management.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage: 'url(/static/images/5abf677361e36504dead75ac_Centralised%2520Management.png)'}} className="portfolio-item-block"></div>
                                                    <div className="portfolio-item-title">{trans('Centralised Management')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('HansaBot is a wholesome solution that lets your business manage chatbots on messaging apps websites via our Inbox and Conversions features')}
                                                    </p>
                                                </a>
                                            </div>
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a href="#" data-ix="show-lightbox" className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf67880c89188ccba357c6_More%2520Leads%2520%2520Sales.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage: 'url(/static/images/5abf67880c89188ccba357c6_More%2520Leads%2520%2520Sales.png)'}} className="portfolio-item-block"></div>
                                                    <div className="portfolio-item-title">{trans('More Leads and Sales')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('CMS and Dynamic Entities let your chatbot engage your customers with media-rich content about latest products and services easily')}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={"portfolio-tab-pane w-tab-pane"+(wTab === "marketers"  ? " w--tab-active" : "")}>
                                    <div className="portfolio-list-wrapper w-dyn-list">
                                        <div className="portfolio-list w-clearfix w-dyn-items w-row">
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a href="#" data-ix="show-lightbox" className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf68217e9bbe4601740e3e_Understand%2520Customer%2520Better.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage:'url(/static/images/5abf68217e9bbe4601740e3e_Understand%2520Customer%2520Better.png)'}} className="portfolio-item-block"></div>
                                                    <div className="portfolio-item-title">{trans('Understand Customers Better')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('Track and follow-up your subscribed unique users via our detail Audience Management and Reports')}
                                                    </p>
                                                </a>
                                            </div>
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a href="#" data-ix="show-lightbox" className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf68c6d0f264da8efb20b7_AB%2520Testing.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage: 'url(/static/images/5abf68c6d0f264da8efb20b7_AB%2520Testing.png)'}} className="portfolio-item-block"></div>
                                                    <div className="portfolio-item-title">{trans('A/B Testing')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('Setting up Action Checkpoint in your flow to enable A/B testing, analyzing conversion paths or goals to optimize your chatbot')}
                                                    </p>
                                                </a>
                                            </div>
                                            <div data-ix="show-block-overlay" className="portfolio-item w-dyn-item w-col w-col-4">
                                                <a href="#" data-ix="show-lightbox" className="portfolio-lightbox-block w-inline-block"
                                                    onClick={this.setLightboxOverlay.bind(this, {src: "/static/images/5abf691b61e3656772ad7690_Reach%2520Audience%2520Efortlessly.png"})}>
                                                    <div data-ix="show-block-overlay" style={{backgroundImage:"url(/static/images/5abf691b61e3656772ad7690_Reach%2520Audience%2520Efortlessly.png)"}} className="portfolio-item-block"></div>
                                                    <div className="portfolio-item-title">{trans('Reach Audience Effortlessly')}</div>
                                                    <p className="portfolio-item-description">
                                                        {trans('It is important for your chatbot to maintain engagement with subscribed end-users via scheduled message push for promotions sales or transactional updates')}
                                                    </p>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.lightboxOverlay  && (
                                <div style={{opacity: 0, display: 'flex'}} data-ix="hide-lightbox" className="portfolio-lightbox-overlay animated fadeIn">
                                    <div className="portfolio-image-wrapper">
                                        <a href="#" data-ix="close-lightbox" className="close-lightbox-button w-inline-block" onClick={this.setLightboxOverlay.bind(this, false)}>
                                            <img src="/static/images/59fed69e519aa500014675ca_Icon-close-thin.png" className="lightbox-close-icon" />
                                        </a>
                                        <img src={this.state.lightboxOverlay.src} className="portfolio-image" />
                                    </div>
                                </div> )}
                            </div>
                        </div>
                    </div>
                </div>
                <div id="intro" className="section feature-section odd">
                    <div className="container w-container">
                        <img src="/static/images/5a956751892ae8000192f84b_browser-1.png" className="browser-mockup-right" />
                        <div className="feature-text-block">
                            <div className="feature-intro-title">{trans('DRAG AND DROP visual BUILDER')}</div>
                            <h2 className="main-feature-title">
                                {trans('Design Your Chatbot Visually')}
                            </h2>
                            <p>
                                {trans('It feels so rewarding and fun to make chatbots using HansaBot Our powerful visual editor enables teamwork between developers and business helps mapping business processes into chatbots')}
                            </p>
                            <div className="small-features-wrapper">
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                                    <div className="long-feature-icon-wrapper">
                                        <img src="/static/images/5a140b449dc83b0001aade79_icon-eye.png" className="long-feature-icon" width="32" />
                                    </div>
                                    <div className="long-feature-title uppercase">{trans('What you see is what you get')}</div>
                                    <div className="small-paragraph">{trans('Creating a chatbot is as easy as drawing a flow chart')}</div>
                                </div>
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                                    <div className="long-feature-icon-wrapper">
                                        <img src="/static/images/5a140b589dc83b0001aade81_icon-test.png" className="long-feature-icon" width="32" />
                                    </div>
                                    <div className="long-feature-title uppercase">{trans('Live Testing and Debugger')}</div>
                                    <div className="small-paragraph">{trans('Train and test your chatbot as if they went live')}</div>
                                </div>
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                                    <div className="long-feature-icon-wrapper">
                                        <img src="/static/images/5a140b6db3280e0001fbf6ac_icon-cms.png" className="long-feature-icon" width="32" />
                                    </div>
                                    <div className="long-feature-title uppercase">{trans('CMS')}&nbsp;</div>
                                    <div className="small-paragraph">{trans('Define and manage your dynamic data easily')}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section feature-section">
                    <div className="container w-container">
                        <img src="/static/images/5a9672f8892ae80001944fa0_browser-4.png" className="browser-mockup-left" />
                        <div className="feature-text-block right">
                            <div className="feature-intro-title">{trans('Audience segment and performance tracking')}}</div>
                            <h2 className="main-feature-title">
                                {trans('Monitoring and Tracking')}
                            </h2>
                            <p>
                                {trans('A chatbot is a great first step to initiate relationships with your customers HansaBot provides tools for chatbot owners to nurture those relationships even further')}
                            </p>
                            <div className="small-features-wrapper">
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                                    <div className="long-feature-icon-wrapper">
                                        <img src="/static/images/5a140b809dc83b0001aade8f_icon-chart.png" className="long-feature-icon" width="32" />
                                    </div>
                                    <div className="long-feature-title uppercase">{trans('Audience Segments and Analytics')}</div>
                                    <div className="small-paragraph">{trans('Understand segmentation and behaviors of your customers')}&nbsp;</div>
                                </div>
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                                    <div className="long-feature-icon-wrapper">
                                        <img src="/static/images/5a140b9cb3280e0001fbf6bc_icon-broadcast.png" className="long-feature-icon" width="32" />
                                    </div>
                                    <div className="long-feature-title uppercase">{trans('Conversions and Checkpoints')}</div>
                                    <div className="small-paragraph">{trans('Capture important conversion checkpoints and your customers enquiries bookings or orders')}</div>
                                </div>
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section tint">
                    <div className="container w-container">
                        <div className="section-title-wrapper full-centered">
                            <div className="small-section-title">{trans('business usecases')}</div>
                            <h2 className="section-title">{trans('Are Chatbots ready for Businesses')}</h2>
                            <div className="section-description desc-what-is-chatbot">
                                {trans('Chatbots are virtual agents that converse with your customers through messenger apps SMS or websites They help leveraging your business in marketing sales and support')}
                            </div>
                        </div>
                        <div className="usecase-list-wrapper w-dyn-list">
                            <div className="usecase-list w-dyn-items w-row">
                                <div className="usecase-item w-dyn-item w-col w-col-3">
                                    <a href="#" style={{backgroundImage: 'url(/static/images/5a1d256c7ceb0c000128e6e0_usecase-sport.jpg)'}}
                                        className="portfolio-image-block medium w-inline-block">
                                        <div className="portfolio-overlay-block-fake">
                                            <div className="portfolio-overlay-content-wrapper-faker">
                                                <div className="portfolio-block-title-fake">{trans('Sport and Entertainment')}</div>
                                                <div className="portfolio-block-subtitle-fake">
                                                    {trans('Bots will give fans the sense of being part of a conversation with a fellow supporter of their favorite team')}
                                                </div>
                                                <div className="button text-button homepage-ussecase-button-fake">{trans('More Details')}</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="usecase-item w-dyn-item w-col w-col-3">
                                    <a href="#" style={{backgroundImage: "url(/static/images/5a1d25a98802490001d454a9_usecase-health.jpg)"}}
                                        className="portfolio-image-block medium w-inline-block">
                                        <div className="portfolio-overlay-block-fake">
                                            <div className="portfolio-overlay-content-wrapper-faker">
                                                <div className="portfolio-block-title-fake">{trans('Healthcare')}</div>
                                                <div className="portfolio-block-subtitle-fake">
                                                    {trans('Chatbots are capable of detecting symptoms, assisting in appointment booking record tracking')}
                                                </div>
                                                <div className="button text-button homepage-ussecase-button-fake">{trans('More Details')}</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="usecase-item w-dyn-item w-col w-col-3">
                                    <a href="#" style={{backgroundImage: "url(/static/images/5a1d25b65c97d3000174ce6f_usecase-travel.jpg)"}}
                                        className="portfolio-image-block medium w-inline-block">
                                        <div className="portfolio-overlay-block-fake">
                                            <div className="portfolio-overlay-content-wrapper-faker">
                                                <div className="portfolio-block-title-fake">{trans('Travel and Transportation')}</div>
                                                <div className="portfolio-block-subtitle-fake">
                                                    {trans('Chatbot the perfect vehicle for getaways Consumers can do planning riding booking servicing with a chatbot')}
                                                </div>
                                                <div className="button text-button homepage-ussecase-button-fake">{trans('More Details')}</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="usecase-item w-dyn-item w-col w-col-3">
                                    <a href="#" style={{backgroundImage: "url(/static/images/5a1d25c28802490001d454b8_usecase-ec.jpg)"}}
                                        className="portfolio-image-block medium w-inline-block">
                                        <div className="portfolio-overlay-block-fake">
                                            <div className="portfolio-overlay-content-wrapper-faker">
                                                <div className="portfolio-block-title-fake">{trans('E commerce')}</div>
                                                <div className="portfolio-block-subtitle-fake">{trans('Lets your user has a new shopping experience')}</div>
                                                <div className="button text-button homepage-ussecase-button-fake">{trans('More Details')}</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <a href="#" className="button continue-reading hero-button w-button">{trans('View all business usecases')}</a>
                </div>
                <div id="intro" className="section feature-section odd">
                    <div className="container w-container">
                        <img src="/static/images/5a9568eeb010650001ba1e40_browser-2.png" className="browser-mockup-right" />
                        <div className="feature-text-block">
                            <div className="feature-intro-title">{trans('Reduce the pain for your customer support team')}</div>
                            <h2 className="main-feature-title">
                                {trans('Reach Your Users Effortlessly')}
                            </h2>
                            <p>
                                {trans('A chatbot is a great first step to initiate relationships with your customers HansaBot provides tools for chatbot owners to nurture those relationships even further')}
                            </p>
                            <div className="small-features-wrapper">
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                                    <div className="long-feature-icon-wrapper">
                                        <img src="/static/images/5abf6e76bd7b3be48610e116_marketing.png" className="long-feature-icon" width="32" />
                                    </div>
                                    <div className="long-feature-title uppercase">{trans('Broadcast')}</div>
                                    <div className="small-paragraph">{trans('Engage your audience proactively and keep them up-to-date with your agenda')}</div>
                                </div>
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                                    <div className="long-feature-icon-wrapper">
                                        <img src="/static/images/5a140b589dc83b0001aade81_icon-test.png" className="long-feature-icon" width="32" />
                                    </div>
                                    <div className="long-feature-title uppercase">{trans('Live Chat')}</div>
                                    <div className="small-paragraph">
                                        {trans('You can use complicated and predefined messages for quoting or pricing purpose instead of typing everything')}
                                    </div>
                                </div>
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only"></div>
                                <div style={{opacity: 1, transform: 'translateX(0px) translateY(0px) translateZ(0px)', transition: 'opacity 500ms ease 0s, transform 500ms ease 0s'}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                                    <div className="long-feature-icon-wrapper">
                                        <img src="/static/images/5a140bb19dc83b0001aade9d_icon-humantakover.png" className="long-feature-icon" width="32" />
                                    </div>
                                    <div className="long-feature-title uppercase">{trans('Human Take over')}</div>
                                    <div className="small-paragraph">
                                        {trans('Once a conversation becomes a lead or problem operator can take over and continue the chat seemlessly')}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



















































































































































        <div className="section feature-section">
            <div className="container w-container">
                <img src="/static/images/5ad8a08bffaa093030e10468_browser-3%25203.png" className="browser-mockup-left" />
                <div className="feature-text-block right">
                    <div className="feature-intro-title">{trans('one click multiple platforms')}</div>
                    <h2 className="main-feature-title">
                        {trans('Operate on Multi Channels')}
                    </h2>
                    <p>
                        {trans('Designs your chatbot once and have it published to many places at once')}
                    </p>
                    <div className="small-features-wrapper">
                        <div style={{opacity: "1", transform: "translateX(0px) translateY(0px) translateZ(0px)", transition: "opacity 500ms ease 0s, transform 500ms ease 0s"}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                            <div className="long-feature-icon-wrapper">
                                <img src="/static/images/5a968751b010650001bb6d26_messenger.png" className="long-feature-icon" width="32" />
                            </div>
                            <div className="long-feature-title uppercase">{trans('Facebook Messenger')}</div>
                            <div className="small-paragraph">
                                {trans('Facebook and has 1.2 billion users a month Its time to start exploring opportunities on Facebook Messenger for your business')}
                            </div>
                        </div>
                        <div style={{opacity: "1", transform: "translateX(0px) translateY(0px) translateZ(0px)", transition: "opacity 500ms ease 0s, transform 500ms ease 0s"}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                            <div className="long-feature-icon-wrapper">
                                <img src="/static/images/5a968761fff1bf000160bc4f_internet.png" className="long-feature-icon" width="32" />
                            </div>
                            <div className="long-feature-title uppercase">{trans('Website Widget')}</div>
                            <div className="small-paragraph">
                                {trans('Chatbot can help converting your potential customers by answering FAQ or providing extra info for your products or services')}
                            </div>
                        </div>
                        <div style={{opacity: "1", transform: "translateX(0px) translateY(0px) translateZ(0px)", transition: "opacity 500ms ease 0s, transform 500ms ease 0s"}} data-ix="fade-in-on-scroll" className="long-feature-block title-only">
                            <div className="long-feature-icon-wrapper">
                                <img src="/static/images/5a96876c41e04900018b02db_smartphone.png" className="long-feature-icon" width="32" />
                            </div>
                            <div className="long-feature-title uppercase">{trans('API and SDKs are coming')}</div>
                            <div className="small-paragraph">
                                {trans('We will be releasing our APIs and mobile SDKs shortly in the future for mobile integration soon')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="image-section pricing">
            <div className="image-section-overlay">
                <div className="container w-container">
                    <div className="section-title-wrapper">
                        <div className="small-section-title">{trans('getting excited')}</div>
                        <h2 className="section-title">
                            {trans('Which plan fits you best')}
                        </h2>
                    </div>
                    <div className="pricing-row w-row">
                        <div className="pricing-column w-col w-col-6">
                            <div className="white-pricing-block">
                                <div className="pricing-block-content-wrapper">
                                    <div className="pricing-block-title">{trans('STARTER')}</div>
                                    <div className="pricing-block-price free">{trans('FREE')}</div>
                                    <div className="pricing-block-price subtitle hidden-white">{trans('Thank you')}</div>
                                </div>
                                <ul className="pricing-feature-list w-list-unstyled">
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            <strong>{trans('Unlimited')}</strong> {trans('Messages')}
                                        </p>
                                        <div className="pricing-tooltip-trigger">
                                            <img src="/static/images/5b3a06b5ef85114ba6506805_question%25201.png" className="image-2" />
                                            <div data-w-id="a168e011-d8ef-65b9-1439-28c37a7bdd97" style={{display:"none"}} className="pricing-tooltip">
                                                <div className="pricing-tooltip-arrow">
                                                </div>
                                                <div className="text-block-2">{trans('Inbound and outbound interactions between bot and audience')}</div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b37241c476262308f7baead_infinite-symbol-.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            <strong>{trans('Unlimited')}</strong> {trans('Chat Users')}
                                        </p>
                                        <div className="pricing-tooltip-trigger">
                                            <img src="/static/images/5b3a06b5ef85114ba6506805_question%25201.png" className="image-2" />
                                            <div style={{display:"none"}} className="pricing-tooltip">
                                                <div className="pricing-tooltip-arrow">
                                                </div>
                                                <div className="text-block-2">{trans('Direct end users who talk to your chatbot on website or messenger app')}</div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a05faef85113a285067be_checked.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            20 {trans('Tags')}
                                        </p>
                                        <div className="pricing-tooltip-trigger">
                                            <img src="/static/images/5b3a06b5ef85114ba6506805_question%25201.png" className="image-2" />
                                            <div style={{display:"none"}} className="pricing-tooltip">
                                                <div className="pricing-tooltip-arrow"></div>
                                                <div className="text-block-2">
                                                    {trans('Your Audience can be grouped by tagging for later target campaigns or engagement')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a05faef85113a285067be_checked.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            20 {trans('CMS Items')}
                                        </p>
                                        <div className="pricing-tooltip-trigger">
                                            <img src="/static/images/5b3a06b5ef85114ba6506805_question%25201.png" className="image-2" />
                                            <div style={{display:"none"}} className="pricing-tooltip">
                                                <div className="pricing-tooltip-arrow"></div>
                                                <div className="text-block-2">
                                                    {trans('HansaBot has a built in CMS to help organising your dynamic data These data can be injected into the bot flow later on')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a05faef85113a285067be_checked.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            500 {trans('Subscribers')}
                                        </p>
                                        <div className="pricing-tooltip-trigger">
                                            <img src="/static/images/5b3a06b5ef85114ba6506805_question%25201.png" className="image-2" />
                                            <div style={{display:"none"}} className="pricing-tooltip">
                                                <div className="pricing-tooltip-arrow"></div>
                                                <div className="text-block-2">
                                                    {trans('Up to')} 500 {trans('users can be measured in Audience and receive your Broadcasts')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a060f41dc2d710051da64_padlock%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            {trans('HansaBot Brand persisted')}
                                        </p>
                                        <div className="pricing-tooltip-trigger">
                                            <img src="/static/images/5b3a06b5ef85114ba6506805_question%25201.png" className="image-2" />
                                            <div style={{display:"none"}} className="pricing-tooltip">
                                                <div className="pricing-tooltip-arrow"></div>
                                                <div className="text-block-2">
                                                    {trans('Credit to us Powered by HansaBot will be shown to the end-users')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a060f41dc2d710051da64_padlock%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            {trans('Only Support via HansaBot Community')}
                                        </p>
                                        <div className="pricing-tooltip-trigger">
                                            <img src="/static/images/5b3a06b5ef85114ba6506805_question%25201.png" className="image-2" />
                                            <div style={{display:"none"}} className="pricing-tooltip">
                                                <div className="pricing-tooltip-arrow"></div>
                                                <div className="text-block-2">
                                                    {trans('We try to be as active as possible but not our highest priority of tasks')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div className="pricing-block-content-wrapper bottom">
                                    <a href="#" target="_blank" className="button white-pricing-button free w-button">
                                        {trans('GET STARTED NOW')}
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="pricing-column w-col w-col-6">
                            <div className="white-pricing-block color">
                                <div className="pricing-block-content-wrapper">
                                    <div className="pricing-block-title light">{trans('PRO')}</div>
                                    <div className="pricing-block-price white">{trans('$')}10.00</div>
                                    <div className="pricing-block-price subtitle white">{trans('Per Month')}</div>
                                </div>
                                <ul className="pricing-feature-list w-list-unstyled">
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a04ee41dc2d657051d7eb_infinite-symbol-%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            {trans('Unlimited Messages')}
                                        </p>
                                        <div className="pricing-tooltip-trigger pro">
                                            <img src="/static/images/5b3a08705b72fbd687960031_question%25201.png" className="image-2" />
                                            <div style={{display: "none"}} className="pricing-tooltip pro">
                                                <div className="pricing-tooltip-arrow pro"></div>
                                                <div className="text-block-2">
                                                    {trans('Inbound and outbound interactions between bot and audience')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a04ee41dc2d657051d7eb_infinite-symbol-%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            {trans('Unlimited Chat Users')}
                                        </p>
                                        <div className="pricing-tooltip-trigger pro">
                                            <img src="/static/images/5b3a08705b72fbd687960031_question%25201.png" className="image-2" />
                                            <div style={{display: "none"}} className="pricing-tooltip pro">
                                                <div className="pricing-tooltip-arrow pro"></div>
                                                <div className="text-block-2">
                                                    {trans('Direct end users who talk to your chatbot on website or messenger app')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a04ee41dc2d657051d7eb_infinite-symbol-%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            {trans('Unlimited Tags')}
                                        </p>
                                        <div className="pricing-tooltip-trigger pro">
                                            <img src="/static/images/5b3a08705b72fbd687960031_question%25201.png" className="image-2" />
                                            <div style={{display: "none"}} className="pricing-tooltip pro">
                                                <div className="pricing-tooltip-arrow pro"></div>
                                                <div className="text-block-2">{trans('Tag and add as many tags as you like for your audience')}</div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a04ee41dc2d657051d7eb_infinite-symbol-%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            {trans('Unlimited CMS Items')}
                                        </p>
                                        <div className="pricing-tooltip-trigger pro">
                                            <img src="/static/images/5b3a08705b72fbd687960031_question%25201.png" className="image-2" />
                                            <div style={{display: "none"}} className="pricing-tooltip pro">
                                                <div className="pricing-tooltip-arrow pro"></div>
                                                <div className="text-block-2">{trans('PRO Plan gives you unlimited capacity for CMS')}</div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a049db5401f7eaf881d6c_unlocked%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            <a href="#" className="white-link">{trans('Unlock Subscribers Cap')}</a>
                                            <a href="#" className="white-link"></a>
                                        </p>
                                        <div className="pricing-tooltip-trigger pro">
                                            <img src="/static/images/5b3a08705b72fbd687960031_question%25201.png" className="image-2" />
                                            <div style={{display: "none"}} className="pricing-tooltip pro">
                                                <div className="pricing-tooltip-arrow pro"></div>
                                                <div className="text-block-2">{trans('Unlock the 500 subscribers cap and pay as your bot grow')}</div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a049db5401f7eaf881d6c_unlocked%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            {trans('Unlock Custom Brand')}
                                        </p>
                                        <div className="pricing-tooltip-trigger pro">
                                            <img src="/static/images/5b3a08705b72fbd687960031_question%25201.png" className="image-2" />
                                            <div style={{display: "none"}} className="pricing-tooltip pro">
                                                <div className="pricing-tooltip-arrow pro">
                                                </div>
                                                <div className="text-block-2">
                                                    {trans('Remove Powered By HansaBot and unlock web-widget customisation')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="pricing-feature-item">
                                        <img src="/static/images/5b3a049db5401f7eaf881d6c_unlocked%25201.png" className="pricing-list-icon-home" />
                                        <p className="pricing-feature-text">
                                            {trans('VIP Support via Direct Chat')}
                                        </p>
                                        <div className="pricing-tooltip-trigger pro">
                                            <img src="/static/images/5b3a08705b72fbd687960031_question%25201.png" className="image-2" />
                                            <div style={{display: "none"}} className="pricing-tooltip pro">
                                                <div className="pricing-tooltip-arrow pro"></div>
                                                <div className="text-block-2">
                                                    {trans('Unlock direct chat with our staff for more private and instant support')}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <div className="pricing-block-content-wrapper bottom">
                                    <a href="#" target="_blank" className="button white-pricing-button w-button">{trans('UPGRADE NOW')}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p className="paragraph">
                        <a href="#" className="hero-link white-link">{trans('Click here for more Pricing Plans and Features')}</a>
                        <br />
                        {trans('Can not decide  Do not hesitate to')}
                        <a href="#" className="white-link">{trans('contact us')}</a>!
                    </p>
                </div>
            </div>
        </div>
        <div className="section ccustom-bot">
            <div className="container centered w-container">
                <div className="section-title-wrapper info custom-bot-wrapper">
                    <h2 className="section-title">
                        {trans('Need a custom bot for your brand')}
                    </h2>
                    <div className="section-description">
                        {trans('HansaBot was created so everyone can build their own chatbot. However we understand that not every business is the same. Get in touch with us and you are in good hands')}
                    </div>
                </div>
                <a href="#" className="button w-button">{trans('Contact us')}</a>
            </div>
        </div>
        <div className="image-section get-the-app">
            <div className="image-section-overlay">
                <div className="container w-container">
                    <div className="image-section-overlay-block">
                        <h2 className="section-title">
                            {trans('Need A Starting Point')}
                        </h2>
                        <div className="section-description">
                            {trans('Checkout professional templates contributed by HansaBot and other developers around the world')}
                        </div>
                        <a href="#" className="button purple w-button">{trans('Chatbot Template Marketplace')}</a>
                    </div>
                </div>
            </div>
        </div>
        <NewsLetter trans={trans} />
        <div className="section cta-section">
            <div className="container w-container">
                <h4 className="dark-cta-title">
                    {trans('Join')} 150,000+ {trans('businesses around the world that entrust chatbots to interface with their customers')}.
                </h4>
                <a href="#" data-ix="open-sign-up-popup" target="_blank" className="button cta-button w-button">{trans('Get Started FREE')}</a>
            </div>
        </div>



































                <Footer trans={trans} />
            </div>
        )
    }

}

export default connect(state => ({

}), {

})(Home);






// WEBPACK FOOTER //
// ./src/pages/Home.js